import { animate, query, style, transition, trigger } from '@angular/animations';

const sinMovimiento =
  typeof matchMedia !== 'undefined' && matchMedia('(prefers-reduced-motion: reduce)').matches;

/** Primero sale la pantalla actual (0.2s). Cuando termina, la siguiente aparece en 0.5s. */
const salida = sinMovimiento ? '0ms' : '200ms';
const entrada = sinMovimiento ? '0ms' : '500ms';

export const routeFade = trigger('routeFade', [
  transition('* <=> *', [
    query(':enter', [style({ opacity: 0 })], { optional: true }),
    query(
      ':leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          display: 'block',
          pointerEvents: 'none',
          transform: 'translateX(0)',
        }),
      ],
      { optional: true },
    ),
    query(
      ':leave',
      [animate(`${salida} ease-in-out`, style({ opacity: 0, transform: 'translateX(3rem)' }))],
      { optional: true },
    ),
    query(':enter', [animate(`${entrada} ease-out`, style({ opacity: 1 }))], { optional: true }),
  ]),
]);
